import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-provider-modal',
  templateUrl: './create-provider-modal.component.html',
})
export class CreateProviderModalComponent {
  constructor(private activeModal: NgbActiveModal) {}

  close() {
    this.activeModal.dismiss();
  }
}
